// @flow
import type { ILoaderService } from '../../loader';

import { scrollToBlockById, scrollToElement } from '../../../../utils/common-helper';
import { getStoreTopUpGameSku } from '../../../helpers/customCodeSettings';
import {
  isLoginLastSource, LOGIN_SOURCES, getLastLoginSource, clearLastLoginSource
} from '../../login';
import { topupUserServiceObserver } from '../../topup/services';

export class StoreLoaderService implements ILoaderService {
  _id: string;

  constructor() {
    this._id = getLastLoginSource();
  }

  // eslint-disable-next-line class-methods-use-this
  checkAttach() {
    return isLoginLastSource(LOGIN_SOURCES.STORE_BUY_BUTTON);
  }

  checkDetach() {
    return (isLoginLastSource(LOGIN_SOURCES.STORE_BUY_BUTTON) && !!document.querySelector(`[id='${this._id}'] [data-button-type="buy"]`));
  }

  scrollToButton() {
    scrollToBlockById(this._id, { block: 'center' });
    const interval = setInterval(() => {
      const BB = document.querySelector(`[id='${this._id}'] [data-button-type="buy"] .x-buy-button-widget-simple-payment-button`);
      if (!BB) {
        return;
      }
      BB.click();
      clearInterval(interval);
    }, 50);
  }


  detach() {
    if (this.checkAttach) {
      clearLastLoginSource();
    }
    if (getStoreTopUpGameSku() && !topupUserServiceObserver.target.inputValue) {
      const element = document.querySelector('.block--topup');
      if (element) {
        scrollToElement(element, { block: 'center' });
      }
    } else {
      this.scrollToButton();
    }
  }
}
